module.exports = __webpack_public_path__ + "img/parenting.1f9d3c48.png";